<template>
  <div
    :class="[
      $style.chart,
      $style.chart_by_status,
    ]"
  >
    <div :class="$style.header">
      <div :class="$style.title">
        {{ locales(`chart_${chart.key}_title`) }}
      </div>
      <vgp-switch
        v-if="statusSwitch"
        :is-toggle-on="!!chart.status"
        @onChange="$emit('onToggleStatus')"
      />
    </div>
    <div
      v-if="description"
      :class="$style.description"
    >
      {{ locales(`chart_${chart.key}_description`) }}
    </div>
    <div :class="$style.wrapper">
      <doughnut-chart
        :class="$style.body"
        :id="chart.key"
        :items="items"
        :tooltipTitle="tooltipTitle"
        :static="static"
      />
      <div
        :class="[
          $style.footer,
          isShowStub ? $style.invisible : '',
        ]"
      >
        <div
          :class="$style.item"
          v-for="item in summary"
        >
          <div :class="$style.label">
            {{ item.text }}
          </div>
          <div :class="$style.value">
            {{ item.value }}
          </div>
        </div>
      </div>
      <div
        v-if="isShowStub"
        :class="$style.stub"
      >
        <div :class="$style.stub_item" />
        <div :class="$style.stub_item" />
        <div :class="$style.stub_text">
          {{ locales(`chart_${chart.key}_stub_text`) }}
        </div>
      </div>
      <loader :show="isShowLoader" />
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';
import VgpSwitch from '../../common/VueComponents/checkbox/squareToggle.vue';
import DoughnutChart from '../../common/VueComponents/charts/DoughnutChart.vue';

export default {
  components: {
    Loader,
    VgpSwitch,
    DoughnutChart,
  },
  props: {
    chart: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    description: {
      type: Boolean,
      default: false,
    },
    static: {
      type: Boolean,
      default: false,
    },
    statusSwitch: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'onToggleStatus',
  ],
  data() {
    return {
      locales: __,
      id: 'statuses',
      timeout: null,
      isShowLoader: false,
      tooltipTitle: __(`chart_${this.chart.key}_tooltip_title`),
    };
  },
  computed: {
    isShowStub() {
      return !this.static && !this.data.items.length;
    },
    items() {
      return this.data.items.filter(item => !!item.value);
    },
    summary() {
      return Object.values(this.data.summary);
    }
  },
  watch: {
    data() {
      clearTimeout(this.timeout);
      this.isShowLoader = true;

      this.timeout = setTimeout(() => {
        this.isShowLoader = false;
      }, 1000);
    },
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
};
</script>

<style module src="../less/chart.less"></style>
